/* TypeScript file generated from Empty.re by genType. */
/* eslint-disable import/first */


import * as React from 'react';

// tslint:disable-next-line:no-var-requires
const EmptyBS = require('./Empty.bs');

import {style as ReactDOMRe_style} from '../../src/shims/ReactDOMRe.shim';

// tslint:disable-next-line:interface-over-type-literal
export type Props = {
  readonly className?: string; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string; 
  readonly title: string
};

export const $$default: React.ComponentType<{
  readonly className?: string; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string; 
  readonly title: string
}> = EmptyBS.default;

export default $$default;
